// extracted by css-extract-rspack-plugin
export default {"toggleRow":"OiypZDGBqWksMb_e","toggleLabel":"DOzjlAy9RXg042gB","toggleTitle":"VzBi9XX0XQgUEdN3","toggleDescription":"Q58WVTkiF5gqGhim"};